import React from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ObjetivoV2Patamares({
  isEdicao,
  patamares,
  abrirNovoPatamar,
  abrirEditarPatamar,
  abrirApagarPatamar,
}) {
  return (
    <MDBox mt={2}>
      <Card>
        <MDBox p={2}>
          <MDBox mb={2}>
            <MDTypography variant="h6">Patamares</MDTypography>

            <MDTypography variant="caption" color="text" display="block" mt={0.5}>
              Configuração dos patamares que compõem o objetivo.
            </MDTypography>
          </MDBox>
          <MDBox
            display="flex"
            alignItems={{
              xs: "stretch",
              sm: "center",
            }}
            justifyContent="space-between"
            flexDirection={{
              xs: "column",
              sm: "row",
            }}
            gap={1}
            mb={2}
          >
            <MDBox />

            <MDButton
              color="info"
              onClick={abrirNovoPatamar}
              disabled={!isEdicao}
              startIcon={<AddIcon />}
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
            >
              Adicionar patamar
            </MDButton>
          </MDBox>

          {patamares.length === 0 ? (
            <MDBox minHeight={90} display="flex" alignItems="center" justifyContent="center">
              <MDTypography variant="button" color="text" textAlign="center">
                Ainda não existem patamares configurados.
              </MDTypography>
            </MDBox>
          ) : (
            <MDBox display="flex" flexDirection="column" gap={1.5}>
              {[...patamares]
                .sort((a, b) => Number(a?.ordem || 0) - Number(b?.ordem || 0))
                .map((patamar) => (
                  <Card key={`patamar-${patamar.ordem}`} variant="outlined">
                    <MDBox p={1.5}>
                      <MDBox
                        display="flex"
                        alignItems={{
                          xs: "flex-start",
                          sm: "center",
                        }}
                        justifyContent="space-between"
                        gap={1}
                      >
                        <MDBox minWidth={0}>
                          <MDTypography variant="button" fontWeight="medium">
                            {`${patamar.ordem}. ${patamar.nome}`}
                          </MDTypography>

                          <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                            {patamar.fabricante_nome || patamar.reffabricante || ""}
                          </MDTypography>
                        </MDBox>

                        <MDBox display="flex" alignItems="center" gap={0.5}>
                          <Tooltip title="Editar patamar">
                            <IconButton
                              size="small"
                              color="warning"
                              onClick={() => abrirEditarPatamar(patamar)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>

                          <Tooltip
                            title={
                              patamares.length <= 1
                                ? "O objetivo tem de possuir pelo menos um patamar"
                                : "Apagar patamar"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                color="error"
                                disabled={patamares.length <= 1}
                                onClick={() => abrirApagarPatamar(patamar)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </MDBox>
                      </MDBox>

                      <MDBox
                        mt={1}
                        display="grid"
                        gridTemplateColumns={{
                          xs: "1fr",
                          sm: "repeat(2, minmax(0, 1fr))",
                        }}
                        gap={1}
                      >
                        <MDBox>
                          <MDTypography variant="caption" color="text" display="block">
                            Modo das marcas
                          </MDTypography>

                          <MDTypography variant="button">
                            {patamar.marcas_modo === "TODAS" ? "Todas as marcas" : "Qualquer marca"}
                          </MDTypography>
                        </MDBox>

                        <MDBox>
                          <MDTypography variant="caption" color="text" display="block">
                            Valor da empresa
                          </MDTypography>

                          <MDTypography variant="button">
                            {patamar.valor_empresa === null ||
                            patamar.valor_empresa === undefined ||
                            patamar.valor_empresa === ""
                              ? "-"
                              : patamar.valor_empresa}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                ))}
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
